import {t} from "@lingui/core/macro";

export const labelForGuideLanguageSelect = (
    languageCode: string,
    localName: string,
    isDefault: boolean,
): string => {
    if (isDefault) {
        return t`Default (${localName})`;
    }
    return localName;
};

export const preferredGuideLanguageChangeMessage = (
    languageCode: string,
): string => {
    return t`I'll now respond in ${languageCode}.`;
};
